export {ResetPasswordFormView as ResetPasswordForm} from './ResetPasswordForm.view';
